<template>
  <section class="my-30" v-if="getOpenHouseEnabled && getOpenHouseDays.length > 0">
    <Container>
      <div class="flex justify-center flex-wrap gap-10">
        <div class="flex items-center gap-x-5 bg-[#F3F5FB] py-4 px-6" v-for="day in getOpenHouseDays" :key="day.id">
          <img :src="pinHouse" alt="pin-house" class="w-10 h-10">
          <div class="space-y-2">
            <div>Upcoming Open Day</div>
            <div class="font-bold">
              {{ new Date(day.day) | date('MMM dd, yyyy') }},
              {{ new Date(day.start) | date('h:mm a') }} -
              {{ new Date(day.end) | date('h:mm a') }}
            </div>
          </div>
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from "vuex";
  import { dateFilter } from 'vue-date-fns';

  import Container from '../../components/Container';
  import pinHouse from './pin-house.png';
  
  export default {
    name: 'OpenHouse',
    components: {
      Container,
    },
    data () {
      return {
        pinHouse
      }
    },
    filters: {
      date: dateFilter
    },
    computed: {
      ...mapGetters("tour", ['getOpenHouseEnabled', 'getOpenHouseDays', 'getPrimaryColor']),
    },
  };
</script>
